// extracted by mini-css-extract-plugin
export default {"adminPage":"AdminPage_adminPage__KjOj3","title":"AdminPage_title__85p2c","loading":"AdminPage_loading__fgysf"};